import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userinfo: "",
    value1: null,
    timeRange: []
  },
  mutations: {
    getUseifo(state) {
      Vue.prototype.$axios.post("welcome/info?token=" + sessionStorage.getItem("token"))
        .then((res) => {
          if (res.data.code == 10000) {
            state.userinfo = res.data.data;
          }
        });
    },
    changeData(state, bol) {  // store中的数据只能通过commit mutation来改变

      console.log(1111111111)
      state.value1 = bol
    },
    changetimeRange(state, bol) {  // 修改申报时间
      console.log(bol)

      state.timeRange = bol
    }
  },
  getters: {

  },
  actions: {
    getStatus(context) {

      Vue.prototype.$axios.post("log/systemStatus?token=" + sessionStorage.getItem("token")).then((res) => {
        console.log(res.data.data)

        if (res.data.code == 10000) {
          // var newDate1 = /\d{4}-\d{1,2}-\d{1,2}/g.exec(res.data.data.applyStart)
          // var newDate2 = /\d{4}-\d{1,2}-\d{1,2}/g.exec(res.data.data.applyEnd)
          context.commit("changeData", res.data.data.nums == 0 ? true : false)

          context.commit("changetimeRange", [res.data.data.applyStart, res.data.data.applyEnd])

        }
      });
    },
  },
  modules: {
  }
})
